export const abbreviations = {
  thousand: 'k', // 千
  million: 'm', // 百万
  billion: 'b', // 十亿
};
